import React from 'react';

import { Spacer } from '@zapier/design-system';
import { SizeType } from '@zapier/product-get-help/src/types';

import List from '@zapier/product-get-help/src/components/shared/List';
import RadioInput from '@zapier/product-get-help/src/components/shared/RadioInput';
import Surface from '@zapier/product-get-help/src/components/shared/Surface';

type IconName = any;
type Item = { icon?: IconName; label: string; value: string };

type RadioBlockProps = {
  /** Title */
  title: string;
  /** Radio inputs to list */
  items: Item[];
  /** Function to call when the user clicks on an item. */
  onClick: (item: Item) => void;
  /** Size to display. */
  size?: SizeType;
};

const DEFAULT_ICON: IconName = 'navHelp';

/**
 * Renders a block with a list of items using the `RadioInput` component.
 */
const RadioBlock = ({
  title,
  items: items,
  onClick,
  size = 'large',
}: RadioBlockProps) => {
  const defaultIcon = items.find(item => !!item.icon)
    ? DEFAULT_ICON
    : undefined;

  return (
    <Surface size={size} title={title}>
      <Spacer height={20} />
      <List
        gap={5}
        itemRenderer={(item: Item) => (
          <RadioInput
            icon={item.icon || defaultIcon}
            label={item.label}
            onClick={() => onClick(item)}
          />
        )}
        items={items}
      />
    </Surface>
  );
};

export default RadioBlock;
